import React, { useState, useEffect } from "react";
import { Line } from "@ant-design/plots";
import { Select } from "antd";
import { useTranslation } from "react-i18next";
import { dashboardHistory } from "../../../helpers/helper";
import { listMonth } from "../../../helpers/common";

const { Option } = Select;

function DashboardHistory() {
  const { t } = useTranslation();
  document.title = t("menuTotal");
  const date = new Date();
  const [data, setData] = useState([]);
  const [valueMonth, setValueMonth] = useState(
    `${date.getMonth() + 1},${date.getFullYear()}`
  );
  const handleChange = (value) => {
    setValueMonth(value);
  };
  const listDataMonth = listMonth(date, 7);

  useEffect(() => {
    try {
      const dateTime = valueMonth.split(",");
      const fecthData = async () => {
        let time = {
          month: parseInt(dateTime[0]),
          year: parseInt(dateTime[1]),
        };
        const dataRes = await dashboardHistory(time);
        setData(dataRes);
      };
      fecthData();
    } catch (error) {
      console.log(error);
    }
  }, [valueMonth]);

  const config = {
    data,
    xField: "date",
    yField: "value",
    label: {},
    point: {
      size: 5,
      shape: "diamond",
      style: {
        fill: "white",
        stroke: "#5B8FF9",
        lineWidth: 2,
      },
    },
    tooltip: {
      showMarkers: false,
    },
    state: {
      active: {
        style: {
          shadowBlur: 4,
          stroke: "#000",
          fill: "red",
        },
      },
    },
    interactions: [
      {
        type: "marker-active",
      },
    ],
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <div>
          <div style={{ fontSize: "35px", paddingBottom: "5px" }}>
            {t("scoreChart")}
          </div>
          <div>{`${t("historyChartLogin")} ${valueMonth.split(",")[0]}/${
            valueMonth.split(",")[1]
          }`}</div>
        </div>
        <div style={{ padding: "20px" }}>
          <Select
            showSearch
            options={listDataMonth}
            value={valueMonth}
            onChange={handleChange}
            style={{ width: "200px" }}
          >
            {listDataMonth.length > 0 &&
              listDataMonth.map((key, item) => {
                return (
                  <Option key={key} value={item.valueOf}>
                    {item.label}
                  </Option>
                );
              })}
          </Select>
        </div>
      </div>
      <Line {...config} style={{ padding: "20px" }} />
    </div>
  );
}

export default DashboardHistory;
